import clsx, { type ClassValue } from "clsx";
import slugifyPackage from "slugify";

export function cn(...classes: ClassValue[]) {
  return clsx(classes);
}

export function formatDate(date: string): string {
  const d = new Date(date);
  if (Number.isNaN(d.getTime())) return date;
  return new Intl.DateTimeFormat("en-US", {
    month: "long",
    day: "numeric",
    year: "numeric",
  }).format(d);
}

export function truncate(str: string, length: number): string {
  if (str.length <= length) return str;
  return `${str.slice(0, length).trimEnd()}…`;
}

export function slugify(str: string): string {
  return slugifyPackage(str, { lower: true, strict: true, trim: true });
}
